import { gql } from '@apollo/client';

export type GetWorkspaceDatasetType = {
  dataset: {
    id: string;
    description: string;
    lastSubmitted: string;
    type: string;
    status: string;
    csvFile?: {
      id: string;
      name: string;
      rowCount: number;
      columns: {
        id: string;
        index: number;
        name: string;
        type: string;
      }[];
    };
  };
};

export const GET_WORKSPACE_DATASET = gql`
  query GetWorkspaceDataset($id: ID!) {
    dataset: getWorkspaceDataset(id: $id) {
      id
      description
      lastSubmitted
      type
      status
      csvFile {
        id
        name
        rowCount
        columns {
          id
          index
          name
          type
        }
      }
    }
  }
`;
